const teamInstructions = {
  mentality: {
    offset: 3,
    risk: {
      profiles: [
        {
          mentality: { high: 0, low: 25 },
          passingDirectness: { high: 0, low: 1 },
          closingDown: { high: 0, low: 1 },
          attackingDepthFront: { high: 0, low: 0.5 },
          defensiveDepthFront: { high: 0, low: 0.5 },
          attackingDepthBack: { high: 0, low: 0.5 },
          defensiveDepthBack: { high: 0, low: 0.5 },
          attackingWidth: { high: 0, low: 2 },
          tempo: { high: 0, low: 3 }
        },
        {
          mentality: { high: 0, low: 16.67 },
          attackingDepthFront: { high: 0, low: 0.33 },
          defensiveDepthFront: { high: 0, low: 0.33 },
          attackingDepthBack: { high: 0, low: 0.33 },
          defensiveDepthBack: { high: 0, low: 0.33 },
          attackingWidth: { high: 0, low: 1 },
          tempo: { high: 0, low: 2 }
        },
        {
          mentality: { high: 0, low: 8.33 },
          attackingDepthFront: { high: 0, low: 0.17 },
          defensiveDepthFront: { high: 0, low: 0.17 },
          attackingDepthBack: { high: 0, low: 0.17 },
          defensiveDepthBack: { high: 0, low: 0.17 },
          tempo: { high: 0, low: 1 }
        },
        {},
        {
          mentality: { high: 8.33, low: 0 },
          closingDown: { high: 1, low: 0 },
          attackingDepthFront: { high: 0.17, low: 0 },
          defensiveDepthFront: { high: 0.17, low: 0 },
          attackingDepthBack: { high: 0.17, low: 0 },
          defensiveDepthBack: { high: 0.17, low: 0 },
          attackingWidth: { high: 1, low: 0 },
          tempo: { high: 1, low: 0 }
        },
        {
          mentality: { high: 16.67, low: 0 },
          passingDirectness: { high: 1, low: 0 },
          closingDown: { high: 1, low: 0 },
          attackingDepthFront: { high: 0.33, low: 0 },
          defensiveDepthFront: { high: 0.33, low: 0 },
          attackingDepthBack: { high: 0.33, low: 0 },
          defensiveDepthBack: { high: 0.33, low: 0 },
          attackingWidth: { high: 1, low: 0 },
          tempo: { high: 2, low: 0 }
        },
        {
          mentality: { high: 25, low: 0 },
          passingDirectness: { high: 1, low: 0 },
          closingDown: { high: 1, low: 0 },
          attackingDepthFront: { high: 0.5, low: 0 },
          defensiveDepthFront: { high: 0.5, low: 0 },
          attackingDepthBack: { high: 0.5, low: 0 },
          defensiveDepthBack: { high: 0.5, low: 0 },
          attackingWidth: { high: 2, low: 0 },
          tempo: { high: 3, low: 0 }
        }
      ]
    }
  },

  attackingWidth: { 
    offset: 2, 
    risk: { 
      profiles: [
        { attackingWidth: { high: 0, low: 3 } },
        { attackingWidth: { high: 0, low: 2 } },
        {},
        { attackingWidth: { high: 2, low: 0 } },
        { attackingWidth: { high: 4, low: 0 } },
      ] 
    }
  },

  passIntoSpace: {
    offset: 0,
    risk: {
      profiles: [
        {},
        { passingRisk: { high: 2, low: 0 } }
      ]
    }
  },

  playOutOfDefence: { 
    offset: 0, 
    risk: { 
      profiles: [
        {},
        { clearances: { high: 1, low: 0 } }
      ] 
    }
  },

  passing: {
    offset: 2,
    risk: {
      profiles: [
        {
          passingDirectness: { high: 0, low: 3 },
          tempo: { high: 0, low: 1 }
        },
        {
          passingDirectness: { high: 0, low: 2 }
        },
        {},
        {
          passingDirectness: { high: 1, low: 0 }
        },
        {
          passingDirectness: { high: 3, low: 0 },
          tempo: { high: 1, low: 0 }
        }
      ]
    }
  },

  tempo: { 
    offset: 2, 
    risk: {
      profiles: [
        { tempo: { high: 0, low: 3 } },
        { tempo: { high: 0, low: 2 } },
        {},
        { tempo: { high: 2, low: 0 } },
        { tempo: { high: 4, low: 0 } }
      ]
    }
  },

  timeWasting: { 
    offset: 2, 
    risk: { 
      profiles: [
        { timeWasting: { high: 0, low: 2 } },
        { timeWasting: { high: 0, low: 1 } },
        {}
      ]
    }
  },

  hitEarlyCrosses: { 
    offset: 0, 
    risk: { 
      profiles: [
        {},
        { crossing: { high: 4, low: 0 } }
      ] 
    } 
  },
  
  shootOnSight: { 
    offset: 0, 
    risk: { 
      profiles: [
        {},
        { shootingRisk: { high: 2, low: 0 } }
      ] 
    } 
  },
  
  workBallIntoBox: { 
    offset: 0, 
    risk: { 
      profiles: [
        {},
        {
          crossing: { high: 0, low: 2 },
          shootingRisk: { high: 0, low: 2 }
        }
      ] 
    } 
  },
  
  playForSetPieces: { 
    offset: 0, 
    risk: { 
      profiles: [
        {},
        { playingForSetPieces: { high: 0, low: 2 } }
      ] 
    } 
  },
  
  dribbling: { 
    offset: 1, 
    risk: { 
      profiles: [
        { verticalDribbling: { high: 0, low: 2 } },
        {},
        { verticalDribbling: { high: 2, low: 0 } }
      ] 
    } 
  },
  
  creativeFreedom: { 
    offset: 1, 
    risk: { 
      profiles: [
        {
          lateralMovement: { high: 0, low: 2 },
          creativeFreedom: { high: 0, low: 2 }
        },
        {},
        {
          lateralMovement: { high: 2, low: 0 },
          creativeFreedom: { high: 2, low: 0 }
        }
      ] 
    } 
  },

  useOffsideTrap: { 
    offset: 1, 
    risk: { 
      profiles: [
        { steppingUp: { high: 0, low: 1 } },
        {},
        { steppingUp: { high: 1, low: 0 } }
      ] 
    } 
  },
  
  engagementLine: { 
    offset: 2, 
    risk: { 
      profiles: [
        { defensiveDepthFront: { high: 0, low: 2 } },
        { defensiveDepthFront: { high: 0, low: 1 } },
        {},
        { defensiveDepthFront: { high: 1, low: 0 } },
        { defensiveDepthFront: { high: 2, low: 0 } },
      ] 
    } 
  },
  
  defensiveLine: { 
    offset: 2, 
    risk: { 
      profiles: [
        {
          defensiveDepthFront: { high: 0, low: 0.5 },
          attackingDepthBack: { high: 0, low: 2 },
          defensiveDepthBack: { high: 0, low: 2 }
        },
        {
          defensiveDepthFront: { high: 0, low: 0.25 },
          attackingDepthBack: { high: 0, low: 1 },
          defensiveDepthBack: { high: 0, low: 1 }
        },
        {},
        {
          defensiveDepthFront: { high: 0.25, low: 0 },
          attackingDepthBack: { high: 1, low: 0 },
          defensiveDepthBack: { high: 1, low: 0 }
        },
        {
          defensiveDepthFront: { high: 0.5, low: 0 },
          attackingDepthBack: { high: 2, low: 0 },
          defensiveDepthBack: { high: 2, low: 0 }
        }

      ] 
    } 
  },
  
  defensiveWidth: { 
    offset: 1, 
    risk: { 
      profiles: [
        { defensiveWidth: { high: 0, low: 2 } },
        {},
        { defensiveWidth: { high: 2, low: 0 } }
      ] 
    } 
  },
  
  tighterMarking: { 
    offset: 0, 
    risk: { 
      profiles: [
        {},
        { marking: { high: 2, low: 0 } }
      ] 
    } 
  },
  
  pressing: { 
    offset: 2, 
    risk: { 
      profiles: [
        { closingDown: { high: 0, low: 3 } },
        { closingDown: { high: 0, low: 2 } },
        {},
        { closingDown: { high: 2, low: 0 } },
        { closingDown: { high: 4, low: 0 } },
      ] 
    } 
  },
  
  preventGKDistribution: { 
    offset: 0, 
    risk: { 
      profiles: [
        {},
        { defensiveDepthFront: { high: 0.5, low: 0 } }
      ] 
    } 
  },
  
  tackling: { 
    offset: 1, 
    risk: { 
      profiles: [
        { tackling: { high: 0, low: 2 } },
        {},
        { tackling: { high: 2, low: 0 } }
      ] 
    } 
  },
  
  pressingTrap: { 
    offset: 1, 
    risk: { 
      profiles: [
        { defensiveWidth: { high: 0, low: 2 } },
        {},
        { defensiveWidth: { high: 2, low: 0 } }
      ] 
    } 
  },
  
  crossEngagement: { 
    offset: 1, 
    risk: { 
      profiles: [
        { defensiveWidth: { high: 0, low: 2 } },
        {},
        { defensiveWidth: { high: 2, low: 0 } }
      ] 
    } 
  },
  

  counterPress: { 
    offset: 1, 
    risk: { 
      profiles: [
        { counterPressing: { high: 0, low: 2 } },
        {},
        { counterPressing: { high: 2, low: 0 } }
      ] 
    } 
  },
  
  counter: { 
    offset: 1, 
    risk: { 
      profiles: [
        { counterAttacking: { high: 0, low: 2 } },
        {},
        { counterAttacking: { high: 2, low: 0 } }
      ] 
    } 
  },
  
  goalkeeperInPossession: { 
    offset: 1, 
    risk: { 
      profiles: [
        { counterAttacking: { high: 0, low: 1 } },
        {},
        { counterAttacking: { high: 1, low: 0 } }
      ] 
    } 
  },
};

export default teamInstructions;
